import type { State } from '../../reducer.tsx';

export const isOpen = (state: State) => state.ui.add.isOpen;
